export default __webpack_public_path__ + "static/media/32.9a83d679.jpg";